<template>
<div class="pin-book-editor">
    <button @click="openEditor" class="btn btn-outline-dark btn-sm open-album-editor" data-bs-toggle="modal" data-bs-target="#my-pin-books"><i class="fa-regular fa-pencil"></i> Edit</button>
</div>
</template>

<script>
export default {
    name: "PinBookEditor",
    props: {
        pinBook: Object
    },
    data () {
        return {

        }
    },
    mounted() {

    },
    methods: {

        openEditor () {
            VueEvent.$emit('loadEditAlbum', this.pinBook);
        }

    }
}
</script>
